/* HUMAN MATTER — elora-video-reviews: the swipe is native scroll-snap (CSS). This file only
   1. opens a clip in the section's lightbox when its play button is tapped (Kamil 11.09, after im8health.com: on a phone the
      card is a thumbnail, so the clip opens big) — the lightbox is Dawn's modal-dialog (global.js: Escape, backdrop click,
      focus trap, body scroll lock); the card's video element is moved into the modal's stage, gets its source only now
      (data-on-demand — QA 11.09: Safari fetched whole clips the loader had merely attached), plays with sound and native
      controls; closing the modal (or the clip ending) moves it back to its card, paused and rewound. Closing while the clip
      is still loading cancels it (QA-2 11.09: an aborted play() must not be retried, or the clip plays on unseen),
   2. moves the row by one card from the arrows and keeps the arrows/dots in step with the scroll position,
   3. re-arms itself in the Theme Editor (section load, block select brings that card into view).
   No autoplay anywhere: every clip says something different (Kamil 11.09). Reduced motion: instant scrolling. */
window.Elora = window.Elora || {};

(function () {
  var NS = window.Elora;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function behavior() {
    return reduce && reduce.matches ? 'auto' : 'smooth';
  }

  function gapOf(row) {
    var cs = getComputedStyle(row);
    return parseFloat(cs.columnGap || cs.gap) || 0;
  }

  function lightboxOf(root) {
    var m = document.getElementById(root.dataset.vrLightbox || '');
    return m && typeof m.show === 'function' ? m : null;
  }

  function inLightbox(v) {
    return !!v.closest('[data-vr-lb-stage]');
  }

  function open(modal, stage, v) {
    var lbStage = modal.querySelector('[data-vr-lb-stage]');
    if (!lbStage) return;
    putBack(modal); /* a clip still inside from before */
    if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src; /* the source is fetched only now (data-on-demand) */
    if (!v.getAttribute('poster') && v.dataset.poster) v.poster = v.dataset.poster; /* the big frame while the clip loads */
    v.loop = false;
    v.muted = false;
    v.controls = true;
    lbStage.appendChild(v);
    modal.vrOrigin = stage;
    if (v.dataset.vrBound !== '1') {
      v.dataset.vrBound = '1';
      v.addEventListener('ended', function () { if (inLightbox(v) && modal.hasAttribute('open')) modal.hide(); });
    }
    modal.show(stage.querySelector('[data-vr-play]') || stage);
    var p = null;
    try { p = v.play(); } catch (e) { p = null; }
    if (p && typeof p.then === 'function') {
      p.catch(function (err) {
        /* AbortError = the lightbox was closed before the clip started: leave it. NotAllowedError = sound refused: try muted. */
        if (!inLightbox(v) || !err || err.name !== 'NotAllowedError') return;
        v.muted = true;
        var q = null;
        try { q = v.play(); } catch (e) { q = null; }
        if (q && typeof q.catch === 'function') q.catch(function () {});
      });
    }
  }

  function putBack(modal) {
    var stage = modal.vrOrigin;
    var v = modal.querySelector('video');
    modal.vrOrigin = null;
    if (!stage || !v) return;
    v.pause(); /* always — a play() still pending is aborted by this */
    v.controls = false;
    v.muted = true;
    try { v.currentTime = 0; } catch (e) { /* no metadata yet */ }
    var btn = stage.querySelector('[data-vr-play]');
    if (btn) stage.insertBefore(v, btn); else stage.appendChild(v);
  }

  /* Dawn dispatches modalClosed before it removes the open attribute: look after the current task */
  document.body.addEventListener('modalClosed', function () {
    setTimeout(function () {
      var modals = document.querySelectorAll('[data-vr-lb]:not([open])');
      for (var i = 0; i < modals.length; i++) if (modals[i].vrOrigin) putBack(modals[i]);
    }, 0);
  });

  function build(root) {
    var row = root.querySelector('[data-vr-row]');
    if (!row) return;
    var cards = [].slice.call(row.querySelectorAll('[data-vr-card]'));
    var dots = [].slice.call(root.querySelectorAll('[data-vr-dots] i'));
    var prev = root.querySelector('[data-vr-prev]');
    var next = root.querySelector('[data-vr-next]');

    [].slice.call(row.querySelectorAll('[data-vr-stage]')).forEach(function (stage) {
      var btn = stage.querySelector('[data-vr-play]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var v = stage.querySelector('video');
        var modal = lightboxOf(root);
        if (v && modal) open(modal, stage, v);
      });
    });

    function step(dir) {
      if (!cards.length) return;
      row.scrollBy({ left: dir * (cards[0].getBoundingClientRect().width + gapOf(row)), behavior: behavior() });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    var raf = 0;
    function sync() {
      raf = 0;
      if (!cards.length) return;
      var unit = cards[0].offsetWidth + gapOf(row);
      var idx = Math.max(0, Math.min(cards.length - 1, Math.round(row.scrollLeft / unit)));
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i === idx);
      var max = row.scrollWidth - row.clientWidth - 1;
      if (prev) prev.disabled = row.scrollLeft <= 1;
      if (next) next.disabled = row.scrollLeft >= max;
    }
    row.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(sync); });
    sync();
    root.dataset.eloraVrReady = '1';
  }

  NS.initVideoReviews = function (scope) {
    var roots = (scope || document).querySelectorAll('[data-elora-vr]');
    for (var r = 0; r < roots.length; r++) {
      if (roots[r].dataset.eloraVrReady === '1') continue;
      build(roots[r]);
    }
  };

  function boot() { NS.initVideoReviews(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { NS.initVideoReviews(e.target || document); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('[data-vr-card]') : null;
    if (card) card.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
  });
})();
